import { useEffect } from 'react'

import { rehydrateDeskSessionLock } from '_stores/desk-session-lock.store'

export const useDeskSessionLockSync = (): void => {
  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      rehydrateDeskSessionLock(event)
    }
    window.addEventListener('storage', handleStorage)
    return () => window.removeEventListener('storage', handleStorage)
  }, [])
}
